import type { TableColumns } from '@ff-it/ui';
import type { OutletOrServiceCategoryProduct } from 'modules/supplier/products';
import { formatPressFormat, type PressConfig } from './types';

/**
 * Extra product-index columns for PRESS outlets. Press positions are checked
 * against the vendor's sheet, so they read next to the name — the route
 * composes them into `getProductColumns` between identity and detail columns.
 */
export const pressProductColumns: TableColumns<OutletOrServiceCategoryProduct> = [
  {
    content: 'Section',
    key: 'configuration.section',
    width: 150,
    render: ({ configuration }) => (configuration as PressConfig | null | undefined)?.section,
  },
  {
    content: 'Position',
    key: 'configuration.position',
    width: 150,
    render: ({ configuration }) => (configuration as PressConfig | null | undefined)?.position,
  },
  {
    content: 'Placement',
    key: 'configuration.placement',
    width: 150,
    render: ({ configuration }) => (configuration as PressConfig | null | undefined)?.placement,
  },
  {
    content: 'Format',
    key: 'configuration.format',
    width: 120,
    render: ({ configuration }) => formatPressFormat((configuration as PressConfig | null | undefined)?.format ?? null),
  },
];
